export const blockIconsHardwareFaxNew = (
	<span className='material-symbols-outlined'>fax</span>
);
